<h1 mat-dialog-title>{{ 'addDeviceDialog.title' | translate }}</h1>
<div mat-dialog-content>
  <form #form="ngForm">
    <label class="field">
      <span class="mat-body-strong">{{ 'addDeviceDialog.label' | translate }}</span>
      <mat-form-field appearance="outline">
        <input test-id="label" data-id="new-device-label" matInput name="label" [(ngModel)]="label" required>
        <mat-error>{{ 'addDeviceDialog.errors.labelRequired' | translate }}</mat-error>
      </mat-form-field>
    </label>
    <label class="field">
      <span class="mat-body-strong">{{ 'addDeviceDialog.type' | translate }}</span>
      <mat-form-field appearance="outline">
        <mat-select test-id="type" data-id="new-device-type" name="type" [(ngModel)]="type">
          <mat-option value="reaper">{{ 'addDeviceDialog.typeOptions.reaper' | translate }}</mat-option>
          <mat-option value="importer">{{ 'addDeviceDialog.typeOptions.importer' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </label>
    <label *ngIf="providerOptions" class="field">
      <span class="mat-body-strong">{{ 'addDeviceDialog.storageProvider' | translate }}</span>
      <mat-form-field appearance="outline"
        [matTooltip]="'deviceSettings.provider.info' | translate" matTooltipPosition="right">
        <mat-select
          [value]="provider"
          (selectionChange)="provider = $event.value">
          <mat-option value="site">{{ 'deviceSettings.provider.site' | translate }}</mat-option>
          <mat-option value="project">{{ 'deviceSettings.provider.project' | translate }}</mat-option>
          <mat-optgroup *ngFor="let group of providerOptions" [label]="group.label">
            <mat-option *ngFor="let option of group.providers" [value]="option.value"
              [matTooltip]="option.tooltip" matTooltipPosition="right"
              matTooltipClass="tooltip-preformatted">{{ option.label }}</mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </label>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button test-id="close" data-id="device-modal-close" mat-stroked-button (click)="onClose()">
    {{ 'common.actions.close' | translate }}
  </button>
  <button test-id="add" data-id="device-modal-add" mat-flat-button (click)="onAdd()" color="primary" cdkFocusInitial>
    {{ 'common.actions.add' | translate }}
  </button>
</div>
